import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';

export const HeroSection = () => {
  const scrollToCapabilities = () => {
    document.getElementById('capabilities')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image - PT IMA MONTAZ TEKNINDO Workshop */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_ima-montaz-preview/artifacts/naen9pfr_DJI_20250902110644_0016_D.jpg"
          alt="PT IMA MONTAZ TEKNINDO Workshop Facility"
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay - rgba(0,0,0,0.35) */}
        <div 
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.35)' }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-32">
        <div className="max-w-4xl">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8"
          >
            <span className="w-2 h-2 bg-[#FFC107] rounded-full animate-pulse" />
            <span className="text-white/90 text-sm font-medium">ISO 9001:2015 Certified Company</span>
          </motion.div>

          {/* Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6"
          >
            Solusi{' '}
            <span className="text-[#FFC107]">Engineering</span>,{' '}
            Manufacturing & Repair{' '}
            <span className="text-[#FFC107]">Equipment</span> Industri
          </motion.h1>

          {/* Subheadline */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-white/80 leading-relaxed mb-10 max-w-3xl"
          >
            PT IMA MONTAZ TEKNINDO menyediakan layanan machining presisi, fabrication, 
            repair mechanical equipment, dan supply komponen industri untuk sektor 
            oil & gas, manufaktur, dan industri berat.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Link to="/kapabilitas">
              <Button 
                size="lg"
                className="bg-[#FFC107] text-[#001582] hover:bg-[#FFD54F] font-bold text-base px-8 py-6 rounded-xl shadow-lg hover:shadow-xl transition-all"
                data-testid="hero-cta-capabilities"
              >
                Lihat Kapabilitas
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
            <Link to="/produk">
              <Button 
                size="lg"
                variant="outline"
                className="border-2 border-white/30 text-white hover:bg-white/10 font-semibold text-base px-8 py-6 rounded-xl backdrop-blur-sm"
                data-testid="hero-cta-products"
              >
                Lihat Produk
              </Button>
            </Link>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="grid grid-cols-3 gap-6 mt-16 pt-10 border-t border-white/10"
          >
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-[#FFC107]">100+</p>
              <p className="text-white/70 text-sm mt-1">Klien Terpercaya</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-[#FFC107]">ISO</p>
              <p className="text-white/70 text-sm mt-1">9001:2015 Certified</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-[#FFC107]">6+</p>
              <p className="text-white/70 text-sm mt-1">Kategori Produk</p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.6 }}
        onClick={scrollToCapabilities}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors cursor-pointer"
        data-testid="scroll-indicator"
      >
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
        >
          <ChevronDown className="w-6 h-6" />
        </motion.div>
      </motion.button>
    </section>
  );
};

export default HeroSection;
